var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoralprintLogoLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 69.878,
    viewBox: "0 0 400 69.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoralPrint-logo-long") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.69,41.3a7.656,7.656,0,1,0-7.656-7.656A7.671,7.671,0,0,0,208.69,41.3Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.176,12.462A22.054,22.054,0,1,1,55.122,34.515,22.072,22.072,0,0,1,77.176,12.462Zm0,10.272A11.782,11.782,0,1,0,88.959,34.515,11.781,11.781,0,0,0,77.176,22.734Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,56.64H102.828V34.515a22.071,22.071,0,0,1,22.054-22.053H129.6V22.734h-4.721A11.764,11.764,0,0,0,113.1,34.515Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.832,12.462a22.072,22.072,0,0,1,22.054,22.054V56.64H164.614V53.149a22.05,22.05,0,1,1-11.783-40.687Zm0,10.272a11.782,11.782,0,1,0,11.783,11.782A11.764,11.764,0,0,0,152.832,22.734Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.701,
    width: 10.272,
    height: 56.639,
    style: {
      fill: "#0073d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.766,42.428a28.29,28.29,0,1,1-.981-29.854l-8.506,5.7A18.017,18.017,0,1,0,43.9,37.293Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.314,46.3a11.782,11.782,0,1,0-11.782-11.78A11.753,11.753,0,0,0,247.314,46.3Zm-11.781,23.58H225.261V34.515a22.054,22.054,0,0,1,44.108,0c0,17.414-19.3,27.852-33.835,18.646Zm70.73-57.417V56.64h10.272V12.461ZM393.847,56.64H400V46.368h-6.152a11.783,11.783,0,0,1-11.783-11.782V29.908h11.783V19.636H382.065V7.9H371.794V34.586A22.057,22.057,0,0,0,393.847,56.64ZM283.414,34.515A11.764,11.764,0,0,1,295.2,22.734h4.721V12.462H295.2a22.071,22.071,0,0,0-22.054,22.053V56.64h10.272Zm39.188,0V56.64h10.272V34.516a11.782,11.782,0,0,1,23.565,0V56.64H366.71V34.517a22.054,22.054,0,0,0-44.108,0Z",
    style: {
      fill: "#0073d2",
      fillRule: "evenodd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralprintLogoLong);
export default __webpack_public_path__ + "static/media/coralprint-logo-long.2c2e0c04c84bf87c72359ee7134ad1b1.svg";
export { ForwardRef as ReactComponent };